<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "app",
  data() {
    return {
      value1: "",
      value2: ""
    };
  }
};
</script>

<style>
</style>
